const osTriplePlayProviderOptions = [
  {
    label: 'Maak je keuze...',
    value: '',
    attrs: {
      disabled: true,
      selected: true,
    },
  },
  { label: 'Geen huidige provider', value: 0 },
  {
    value: '66',
    label: 'Budget Internet',
  },
  {
    value: '64',
    label: 'Caiway',
  },
  {
    value: '67',
    label: 'DELTA',
  },
  {
    value: '21',
    label: 'KPN',
  },
  {
    value: '63',
    label: 'Odido',
  },
  {
    value: '56',
    label: 'Online.nl',
  },
  {
    value: '65',
    label: 'Youfone',
  },
  {
    value: '33',
    label: 'Ziggo',
  },
];

export default osTriplePlayProviderOptions;
